module.exports = __webpack_public_path__ + "img/indigent4_7-8-2021.08aae2a8.jpg";